import Control from 'ol/control/Control'

import { setMeasure, hideMeasure } from '../map/measure'
import { OPERATION } from '../handlers'

// Measure length button
export class LengthControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    if (options.id) button.id = options.id;
    button.title = 'Mål lengde';
    button.innerHTML = '<i class="material-icons">straighten</i>';
    button.innerHTML = '<i class="material-icons">linear_scale</i>';
    button.innerHTML = '<i class="material-icons">timeline</i>';
    button.innerHTML = '<i class="material-icons">show_chart</i>';
    // button.innerHTML = '<i class="material-icons">&#128207; &#x1F4CF;</i>';

    const element = document.createElement('div');
    element.className = 'measure-length ol-unselectable ol-control';
    element.appendChild(button);
    if (options.position) element.style.bottom = options.position + 'px';

    super({ element: element, target: options.target });

    button.addEventListener('click', this.toggleMeasure.bind(this));
  }

  toggleMeasure = () => {
    const control = document.querySelector('.measure-length');
    control.classList.toggle('active');
    const active = control.classList.contains('active');
    if (!active) hideMeasure();
    const info = document.querySelector('.lift')?.id === 'toolbar_info';
    if (['add', 'edit'].indexOf(OPERATION) > -1 || info) {
      control.classList.remove('active');
    } else {
      document.querySelector('.measure-area').classList.remove('active');
      setMeasure(active);
    }
  };
}

